/** @format */

import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';
import Button from 'components/CustomButtons/Button';
import authNavbarStyle from 'assets/jss/material-dashboard-pro-react/components/authNavbarStyle.jsx';

class AuthNavbarExt extends React.Component {
    render() {
        const { classes, color } = this.props;
        const appBarClasses = cx({
            [' ' + classes[color]]: color,
        });
        return (
            <AppBar position="static" className={classes.appBar + appBarClasses}>
                <Toolbar className={classes.container}>
                    <Hidden smDown>
                        <div className={classes.flex}>
                            <Button href="#" className={classes.title} color="transparent">
                                <div className={classes.fullPage} style={{ width: '0px', height: '0px' }} />
                            </Button>
                        </div>
                    </Hidden>
                </Toolbar>
            </AppBar>
        );
    }
}

AuthNavbarExt.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
    brandText: PropTypes.string,
};

export default withStyles(authNavbarStyle)(AuthNavbarExt);
